import { mapState as rootMapState } from 'pinia';
import { useUserStore, usePageStore } from '@/store';
import { mapState, mapActions } from '@/store/helpers';
import getUseStore from './_store';
import util from '../../common/util';
import { mapAsyncData } from '../../plugins/asyncData';
import searchMixin from './center-adapt';
import { asyncData } from './async-data';
import * as TYPES from './_store/types';
import MlsDesclaimer from '../md-footer/mls-disclaimer.vue';
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';
import { buildUrl } from '@/router/index.js';

export default {
    i18next: {
        ns: 'md-house'
    },
    mixins: [searchMixin, spaceMixin('colorBlock'), colorMixin()],
    _getUseStore: getUseStore,
    asyncData: mapAsyncData(asyncData),
    components: { MlsDesclaimer },
    provide() {
        const me = this;
        return {
            moreInfo() {
                return {
                    moreText: me.moreText,
                    moreLinkPurpose: me.moreLinkPurpose,
                    moreLink: me.moreLink
                };
            },
            topSwiperOption() {
                let defaultOptions = {};
                if (me.autoplay) {
                    defaultOptions.autoplay = {
                        delay: me.playInterval ? me.playInterval * 1000 : 3000
                        // disableOnInteraction: false
                    };
                } else {
                    defaultOptions.autoplay = false;
                }
                if (me.speed) {
                    defaultOptions.speed = me.speed;
                }
                return defaultOptions;
            }
        };
    },
    data: function() {
        return {
            more: null,
            listingSource: '',
            title: '',
            desc: '',
            style: 'standard',
            presetFilters: [],
            presetFiltersV2: {},
            listingSortOptions: [],
            count: 3,
            waiting: false,
            bgType: 'color',
            pictureOption: {
                src: {},
                mobileSrc: {}
            },
            maskOption: {
                showMask: true,
                maskColor: 'rgba(25,25,25,0.5)'
            },
            searchId: '', // cms编辑链接后，保存时会存入
            priceColor: ''
        };
    },
    beforeMount() {
        this.request = util.throttledRequest();
        this.refresh = util.throttle(this.refresh);
        // if (!this.result) {
        //     this.setWaiting(true);
        //     this.refresh();
        // }
    },
    computed: {
        ...rootMapState(usePageStore, {
            page: store => store.page || {},
            siteId: 'siteId',
            soldListingFlag: 'soldListingFlag'
        }),
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        ...mapState({
            result: store => store.result
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        usePicture() {
            return util.getImgSrcByPlatform(this.pictureOption, this.isMobileSize);
        },
        maskShow() {
            return this.bgType === 'image' ? this.maskOption.showMask : false
        },
        globalData({ page }) {
            return page;
        },
        wordPressSSR({ page }) {
            return page.wordPressSSR;
        },
        isSold() {
            const soldReg = new RegExp(`^${this.soldListingFlag}\\+`);
            if (
                this.listingSource === 'sold listings' ||
                soldReg.test(this.listingSource)
            ) {
                return true;
            } else {
                return false;
            }
        },
        searchUrl() {
            return this.isSold ? buildUrl({ name: 'sold-listing' }) : buildUrl({ name: 'listing' });
        },
        moreLinkPurpose() {
            return this.$t(
                this.isSold
                    ? 'md-house.moreSoldListing'
                    : 'md-house.moreListings'
            );
        },
        listingSort() {
            let firstSort = this.listingSortOptions[0];
            return firstSort && firstSort.value;
        },
        moreText({ wordPressSSR }) {
            return this.more && !wordPressSSR && this.more.text;
        },
        moreShow({ more, moreText }) {
            return more?.show && moreText;
        },
        moreStyle() {
            return (
                this.more &&
                (this.isMobileSize ? this.more.mobileStyle : this.more.pcStyle)
            );
        },
        morePosition() {
            return this.more && this.more.position;
        },
        moreLink() {
            if (!this.more) {
                return '';
            }
            if (this.featureArea && this.more?.toAreaSearch) {
                return (
                    this.featureArea?.nbrSearchUrl ||
                    this.featureArea?.citySearchUrl ||
                    ''
                );
            }
            if (this.more.link) {
                let link = this.more.link;
                let mode = this.more.mode;
                let operator = link.indexOf('?') !== -1 ? '&' : '?';
                mode = mode ? encodeURIComponent(mode) : 'grid';
                return `${link}${operator}mode=${mode}`;
            }
            if (this.searchId) {
                return util.setQueryField(
                    { searchId: this.searchId },
                    this.searchUrl
                );
            }
            let more = Object.assign({}, this.more);
            more.mapData = JSON.stringify(
                Object.assign(
                    { property_gathering_amount: 10, zoom: 12 },
                    more.mapSetting
                )
            );
            delete more.mapSetting;
            delete more.text;
            more.mode = more.mode || 'grid';
            const params = Object.assign(
                {
                    listingSortOptions: JSON.stringify(this.listingSortOptions),
                    listingSource: this.listingSource,
                    presetParams: JSON.stringify(this.presetParams)
                },
                more
            );
            if (this.presetParams.rect) {
                let rect = this.presetParams.rect;
                params.rect = rect;
                delete this.presetParams.rect;
            }

            return util.setQueryField(params, this.searchUrl);
        }
    },
    methods: {
        ...mapActions({
            setResult: TYPES.SET_RESULT,
            setWaiting: TYPES.SET_WAITING
        }),
    },
    watch: {
        count(val) {
            if (val <= 0) {
                this.setResult(null);
            }
        }
    }
};
